<template>
    <section class="filters">
        <div class="filters__header">
            <span class="filters__title">
                <v-icon color="#1b2f5a" class="mr-2">mdi-tune-variant</v-icon>
                {{ language=='Ελληνικά'? 'Φίλτρα' : 'Filters' }}
            </span>
            <span v-if="activeCount" class="filters__count">{{ activeCount }}</span>
            <v-spacer />
            <v-btn v-if="activeCount" text small color="#ad282d" @click="resetFilters()">
                <v-icon left small>mdi-close</v-icon>
                {{ language=='Ελληνικά'? 'Καθαρισμός' : 'Clear' }}
            </v-btn>
        </div>

        <v-row>
            <v-col v-if="partner" cols="12" md="6" class="filters__fields">
                <v-autocomplete
                    v-model="filter.title"
                    :items="titles"
                    :label="language=='Ελληνικά'? 'Αναζήτηση επιχείρησης' : 'Search business'"
                    prepend-inner-icon="mdi-magnify"
                    color="#1b2f5a"
                    menu-props="auto"
                    outlined
                    dense
                    hide-details
                    clearable
                    return-object
                />
                <div class="filters__pair">
                    <v-select
                        v-model="filter.category"
                        :items="categories"
                        item-text="title"
                        item-value="id"
                        :label="language=='Ελληνικά'? 'Κατηγορία' : 'Category'"
                        prepend-inner-icon="mdi-shape-outline"
                        color="#1b2f5a"
                        outlined
                        dense
                        hide-details
                        clearable
                    />
                    <v-select
                        v-model="filter.sort"
                        :items="sortItems"
                        :label="language=='Ελληνικά'? 'Ταξινόμηση' : 'Sort'"
                        prepend-inner-icon="mdi-sort"
                        color="#1b2f5a"
                        outlined
                        dense
                        hide-details
                        clearable
                    />
                </div>
                <template v-if="$route.path=='/Partners'">
                    <v-text-field
                        v-model="searchAddress"
                        :label="language=='Ελληνικά'? 'Περιοχή ή διεύθυνση' : 'Area or address'"
                        prepend-inner-icon="mdi-map-marker-outline"
                        append-icon="mdi-arrow-right-circle"
                        color="#1b2f5a"
                        outlined
                        dense
                        hide-details
                        clearable
                        @click:append="getCoordinates"
                        @keyup.enter="getCoordinates"
                    />
                    <div class="filters__location">
                        <v-btn outlined small color="#1b2f5a" :loading="locating" @click="useMyLocation()">
                            <v-icon left small>mdi-crosshairs-gps</v-icon>
                            {{ language=='Ελληνικά'? 'Κοντά μου' : 'Near me' }}
                        </v-btn>
                        <v-btn
                            v-if="hasMap && $vuetify.breakpoint.xs"
                            outlined
                            small
                            color="#1b2f5a"
                            @click="showMap = !showMap"
                        >
                            <v-icon left small>{{ showMap ? 'mdi-map-marker-off-outline' : 'mdi-map-outline' }}</v-icon>
                            {{ showMap ? 'Απόκρυψη χάρτη' : 'Χάρτης' }}
                        </v-btn>
                        <span v-if="locationError" class="filters__error">
                            {{ language=='Ελληνικά'? 'Δεν ήταν δυνατός ο εντοπισμός της τοποθεσίας σας.' : 'Your location could not be found.' }}
                        </span>
                        <span v-else-if="filter.center" class="filters__hint">
                            {{ language=='Ελληνικά'? 'Εμφανίζονται επιχειρήσεις σε απόσταση έως 5 χλμ.' : 'Showing businesses within 5 km.' }}
                        </span>
                    </div>
                </template>
            </v-col>
            <!-- on phones the map waits behind the "Χάρτης" button, so it is not loaded for nothing -->
            <v-col v-if="hasMap && (showMap || !$vuetify.breakpoint.xs)" cols="12" md="6">
                <div class="filters__map">
                    <gmap-map
                        :center="center"
                        :zoom="zoom"
                        :options="options"
                        style="width: 100%; height: 100%;"
                    >
                        <gmap-marker
                            v-for="(marker, index) in markers"
                            :key="index"
                            :position="marker.position"
                            :clickable="true"
                            @click="openMarker(marker.id)"
                        >
                            <gmap-info-window
                                :closeclick="true"
                                @closeclick="openMarker(null)"
                                :opened="openedMarkerID === marker.id"
                            >
                                <router-link :to="`/Partner?id=${marker.id}`"> {{`${marker.title} - ${marker.type}`}}</router-link>
                            </gmap-info-window>
                        </gmap-marker>
                        <gmap-marker
                            :position="center"
                            :icon="{
                                url: locationMarker,
                                scaledSize: {width: 28, height: 28},
                                anchor: {x: 14, y: 14}
                            }"
                        />
                    </gmap-map>
                </div>
            </v-col>
        </v-row>
    </section>
</template>

<script>
    import '@/plugins/google-maps'
    import restApi from "@/rest-api"
    import places from "@/services/places-api"

    export default {
        data() {
            return {
                showMap: false,
                filter:{
                    "available": true,
                    "approved": true,
                    "address": null,
                    "center": null
                },
                zoom: 17,
                partner: false,
                types: [],
                categories: [],
                addresses: [],
                titles: [],
                center: { lat: 37.9303581, lng: 23.7013619 },
                markers: [
                    {
                    }
                ],
                options: {
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: true,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUI: false
                },
                sortItems: [
                    { text: "Όνομα Αύξουσα", value: "title_asc" },
                    { text: "Όνομα Φθίνουσα", value: "title_desc" },
                    { text: "Πιο πρόσφατο", value: "createdAt_desc" }
                ],
                searchAddress: '',
                openedMarkerID: null,
                locating: false,
                locationError: false,
                // "you are here" dot; replaces a 333 KB animated GIF
                locationMarker: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"><circle cx="14" cy="14" r="12" fill="#ad282d" fill-opacity="0.25"/><circle cx="14" cy="14" r="6" fill="#ad282d" stroke="#fff" stroke-width="2"/></svg>'),
            }
        },
        watch:{
            'filter.category': {
                handler() {
                    this.fetchFilters()
                    this.$emit('fetchData', this.filter)
                }
            },
            'filter.title': {
                handler() {
                    this.fetchFilters()
                    this.$emit('fetchData', this.filter)
                }
            },
            'filter.center': {
                handler() {
                    this.fetchFilters()
                    this.$emit('fetchData', this.filter)
                }
            }
            ,
            'filter.sort': {
                handler() {
                    this.fetchFilters()
                    this.$emit('fetchData', this.filter)
                }
            }
        },
        created() {
            this.fetchFilters()
            this.$emit('fetchData',this.filter)
            // the location is only asked for when the visitor presses "Κοντά μου", not on page load
        },
        computed: {
            hasMap() {
                return this.$route.path == '/Partners'
            },
            activeCount() {
                return ['title', 'category', 'sort', 'center'].filter(key => this.filter[key]).length
            },
            language() {
                return this.$store.getters.getLanguage.language
            }
        },
        methods: {
            getCategories() {
                var search = `/partner/categories?`;
                if(this.filter.title) {
                    search += 'title='+ this.filter.title + '&'
                } 
                if(this.filter.center) {
                    search += 'address='+ this.filter.center
                }
                restApi
                .get(search)
                .then(response => {
                    this.categories = response
                })
                .catch((error) => {
                    console.log(error)
                });
            },
            // submitFilters() {
            //     if(this.$route.path==="/Partners"){
            //         this.fetchFilters()
            //     }
            //     this.$emit('fetchData',this.filter)
            // },
            openMarker(id) {
                this.openedMarkerID = id
            },
            fetchFilters() {
                this.fetchMapAddresses()
                this.fetchTitles()
                this.getCategories()
                this.partner = true
            },
            resetFilters() {
                // keep only approved, available partners: an empty filter also listed pending ones
                this.filter = {
                    available: true,
                    approved: true,
                    address: null,
                    center: null
                }
                this.searchAddress = ''
                this.locationError = false
                this.zoom = 17
                this.fetchFilters()
                this.$emit('fetchData', this.filter)
            },
            useMyLocation() {
                this.locating = true
                this.locationError = false
                this.$getLocation({ enableHighAccuracy: false, timeout: 10000 }).then(coordinates => {
                    this.center = coordinates
                    this.zoom = 14
                    this.searchAddress = ''
                    this.filter.center = coordinates.lat + ',' + coordinates.lng
                }).catch(() => {
                    this.locationError = true
                }).finally(() => {
                    this.locating = false
                })
            },
            fetchMapAddresses() {
                var search = `/partner/map/addresses?`;
                if(this.filter.title) {
                    search += 'title='+ this.filter.title + '&'
                } 
                if(this.filter.center) {
                    search += 'address='+ this.filter.center + '&'
                } 
                if(this.filter.category) {
                    search += 'category='+ this.filter.category + '&'
                }
                restApi
                .get(search)
                .then(response => {
                    this.markers = response.map( function (address) {
                        if (address.coordinates) {
                            var coordinates = address.coordinates.split(',')
                            return {
                                position: {
                                    lat: parseFloat(coordinates[0]),
                                    lng: parseFloat(coordinates[1])
                                },
                                id: address.id,
                                title: address.title,
                                type: address.type
                            }
                        } else {
                            return {
                                position: {
                                    lat: 0,
                                    lng: 0
                                },
                                id: address.id,
                                title: address.title,
                                type: address.type
                            }
                        }
                    })
                })
                .catch((error) => {
                    console.log(error);
                })
            },
            fetchTitles() {
                var search = `/partner/titles?`;
                if(this.filter.center) {
                    search += 'address='+ this.filter.center + '&'
                } 
                if(this.filter.category) {
                    search += 'category='+ this.filter.category
                }
                restApi
                .get(search)
                .then(response => {
                    this.titles = response.data.map(partner => partner.title);
                })
                .catch((error) => {
                    console.log(error);
                });
            },
            getCoordinates() {
                places.searchPlace(this.searchAddress)
                .then(resp => {
                    if (!resp || !resp.candidates || !resp.candidates.length) {
                        return
                    }
                    this.searchAddress = resp.candidates[0].formatted_address
                    this.center = { lat: resp.candidates[0].geometry.location.lat, lng: resp.candidates[0].geometry.location.lng }
                    this.zoom = 14
                    this.filter.address = ''
                    this.filter.center = resp.candidates[0].geometry.location.lat + ',' + resp.candidates[0].geometry.location.lng
                })
                .catch(error => { 
                    console.log(error)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.filters {
    background: #fff;
    border: 1px solid rgba(27, 47, 90, 0.1);
    border-radius: 16px;
    padding: 18px 20px 20px;
    box-shadow: 0 1px 2px rgba(27, 47, 90, 0.05);
    color: #1b2f5a;
}

.filters__header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.filters__title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
}

.filters__count {
    margin-left: 8px;
    min-width: 22px;
    padding: 0 7px;
    border-radius: 999px;
    background: #ad282d;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
    text-align: center;
}

.filters__fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

/* Vuetify inputs grow (flex: 1 1 auto); keep them at their own height in this column */
.filters__fields > * {
    flex: 0 0 auto;
}

.filters__pair {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.filters__location {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.filters__error,
.filters__hint {
    font-size: 13px;
}

.filters__error {
    color: #ad282d;
}

.filters__hint {
    color: rgba(27, 47, 90, 0.7);
}

.filters__map {
    height: 100%;
    min-height: 220px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid rgba(27, 47, 90, 0.1);
}

@media (max-width: 600px) {
    .filters__pair {
        grid-template-columns: 1fr;
    }

    .filters__map {
        min-height: 220px;
    }
}
</style>
